<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    parentStoreName="Tags"
    :submit="submit"
    :status="status"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="8">
          <v-row>
            <v-col>
              <ValidationProvider
                ref="text"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.text"
                  label="Label"
                  prepend-inner-icon="fas fa-tag"
                  ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
  import {ValidationProvider, ValidationObserver} from "vee-validate";
  import {mapState} from 'vuex';
  import CrudForm from "@/components/Crud/CrudForm";
  import CrudFormMixin from '@/mixins/crud_form';

  export default {
    mixins: [CrudFormMixin],
    components: {ValidationProvider, ValidationObserver, CrudForm},
    computed: {
      ...mapState({
      })
    },
    data() {
      return {
        storeName: 'Tags',
        title: "Tags",
        data: {
          text: "",
        }
      }
    }
  }
</script>
